import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import EmailIcon from "@mui/icons-material/Email";

const TT = (elem, tgt, vis, text) => {
  let left = 0;
  let leftShift = 0;
  let topShift = 0;
  if (elem) {
    setTimeout(() => {
      left = elem.getBoundingClientRect().left;
      leftShift = Math.round(
        (elem.getBoundingClientRect().width - document.querySelector("#" + tgt).getBoundingClientRect().width) / 2,
      );
      document.querySelector("#" + tgt).style.left = Math.round(left + leftShift) + "px";
      topShift = elem.getBoundingClientRect().top;
      document.querySelector("#" + tgt).style.top = Math.round(topShift) + "px";
    }, 0);
    document.querySelector("#" + tgt).innerHTML = text === undefined ? elem.alt : text;
  }
  document.querySelector("#" + tgt).style.opacity = "show" === vis ? "1" : "0";
};

const ContactContent = () => {
  return (
    <div className="Contact center full-height">
      <p>It'd be great to hear from you!</p>
      <p>Feel free to use any of these methods to get in touch.</p>
      <div id="TTContact" className="tooltip"></div>
      <div id="TTContactIcons" className="tooltip contact-icon-tooltip"></div>
      <p className="contact-methods">
        <a
          href="https://github.com/mattpass"
          target="_blank"
          rel="noreferrer"
          onMouseOver={evt => TT(evt.currentTarget, "TTContactIcons", "show", "GitHub")}
          onMouseOut={() => TT(this, "TTContactIcons", "hide")}
        >
          <GitHubIcon />
        </a>
        <a
          href="https://linkedin.com/in/matt-pass/"
          className="bigger"
          target="_blank"
          rel="noreferrer"
          onMouseOver={evt => TT(evt.currentTarget, "TTContactIcons", "show", "LinkedIn")}
          onMouseOut={() => TT(this, "TTContactIcons", "hide")}
        >
          <LinkedInIcon />
        </a>
        <a
          href="https://x.com/mattpass"
          target="_blank"
          rel="noreferrer"
          onMouseOver={evt => TT(evt.currentTarget, "TTContactIcons", "show", "X")}
          onMouseOut={() => TT(this, "TTContactIcons", "hide")}
        >
          <XIcon />
        </a>
        <a
          href="mailto:matt@mattpass.com"
          className="bigger"
          target="_blank"
          rel="noreferrer"
          onMouseOver={evt => TT(evt.currentTarget, "TTContactIcons", "show", "Email")}
          onMouseOut={() => TT(this, "TTContactIcons", "hide")}
        >
          <EmailIcon />
        </a>
      </p>
      <div className="accreditations">
        <a href="https://www.adsgroup.org.uk/members/matt-pass/" target="_blank" rel="noreferrer">
          <img
            src="/assets/images/accreditations/ads-group.png"
            alt="ADS Group member"
            onMouseOver={evt => {
              TT(evt.target, "TTContact", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTContact", "hide");
            }}
            className="ads-group"
          />
        </a>
        <a href="https://www.credly.com/badges/2db2fef1-2008-42a4-a864-439642cf7a6c" target="_blank" rel="noreferrer">
          <img
            src="/assets/images/accreditations/github-advanced-security.png"
            alt="GitHub Advanced Security accredited"
            onMouseOver={evt => {
              TT(evt.target, "TTContact", "show");
            }}
            onMouseOut={() => {
              TT(this, "TTContact", "hide");
            }}
            className="github-advanced-security"
          />
        </a>
      </div>
    </div>
  );
};

export default ContactContent;
